<template>
  <div class="wrap">
    <img src="../../assets/down/downL.jpg" class="v-bg-img" />
    <div class="v-down-btn"></div>
    <div class="v-down-btn2"></div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.wrap {
  position: relative;
  width: 100%;
}
.v-bg-img {
  width: 100%;
}
.v-down-btn {
  width: 42vw;
  height: 8.5vw;
  background: red;
  position: absolute;
  top: 45vw;
  left: 28vw;
}
.v-down-btn2 {
  width: 42vw;
  height: 9.5vw;
  background:green;
  position: absolute;
  bottom: 22vw;
  left: 28vw;
}
</style>
